function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 26.5C18.5 26.5 17.2745 23.0166 16.3849 21.8192M16.3849 21.8192C17.4148 20.4329 18.6586 19.6086 20 19.6086C21.772 19.6086 23.3736 21.047 24.5369 23.3191M16.3849 21.8192C15.355 20.4329 14.1112 19.6086 12.7698 19.6086C10.8542 19.6086 9.1377 21.2896 7.95882 23.8876M7.95882 23.8876C9.96654 26.0376 12.8263 27.3816 16 27.3816C19.4449 27.3816 22.52 25.798 24.5369 23.3191M7.95882 23.8876C6.12334 21.9221 5 19.283 5 16.3816C5 10.3065 9.92487 5.38159 16 5.38159C22.0751 5.38159 27 10.3065 27 16.3816C27 19.0118 26.0769 21.4264 24.5369 23.3191M15.2698 14.1086C15.2698 15.4893 14.1505 16.6086 12.7698 16.6086C11.3891 16.6086 10.2698 15.4893 10.2698 14.1086C10.2698 12.7278 11.3891 11.6086 12.7698 11.6086C14.1505 11.6086 15.2698 12.7278 15.2698 14.1086ZM22.5 14.1086C22.5 15.4893 21.3807 16.6086 20 16.6086C18.6193 16.6086 17.5 15.4893 17.5 14.1086C17.5 12.7278 18.6193 11.6086 20 11.6086C21.3807 11.6086 22.5 12.7278 22.5 14.1086Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgAgenda(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgenda);
export default __webpack_public_path__ + "static/media/agenda.d3382f8e.svg";
export { ForwardRef as ReactComponent };